import axios, { AxiosError } from 'axios';

export const handleAxiosError = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;

        const method = axiosError.config?.method?.toUpperCase() || 'UNKNOWN_METHOD';
        const url = axiosError.config?.url || 'UNKNOWN_URL';
        const status = axiosError.response?.status;
        const data = axiosError.response?.data as unknown as { message?: string; error?: any } | undefined;
        const responseMessage = data?.message || (typeof data?.error === 'string' ? data?.error : data?.error?.message);

        console.error(
            `%c[Axios Error] ${method} ${url}`,
            'color: red; font-weight: bold;',
            {
                status,
                response: axiosError.response?.data,
                headers: axiosError.config?.headers,
            }
        );

        if (responseMessage) {
            return responseMessage;
        }

        if (status === 401) return "Session expired. Please log in again.";
        if (status === 402) return "Payment Required. Please check your subscription.";
        if (status === 403) return "Access denied.";
        if (status === 404) return "Resource not found.";
        if (status === 429) return "Too many requests. Please slow down and try again shortly.";
        if (status === 500) return "Server error. Please try again later.";

        return "Something went wrong. Please try again.";
    }

    if (error instanceof Error) {
        console.error('%c[Non-Axios Error]', 'color: orange; font-weight: bold;', error);
        return error.message;
    }

    console.error('%c[Unknown Error Type]', 'color: gray; font-weight: bold;', error);
    return 'An unknown error occurred.';
};
